import React from 'react';
import $ from 'jquery';

class PrintDocumentsModal extends React.Component {
    close = () => {
        $('#printDocumentsModal').modal('hide');
    }

    render() {
        return (
            <div className="modal" tabIndex="-1" role="dialog" id='printDocumentsModal'>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Documentos a imprimir</h5>
                            <button type="button" className="close" onClick={this.close} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="" style={{ height: '75vh' }} >
                            <div id="pdfPrinterViewer" style={{ width: "100%", height: "100%" }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintDocumentsModal;